// extracted by mini-css-extract-plugin
export default {"companyStatsTable":"companyStatsTable_companyStatsTable__XXHb+","companyStatsTable-wrapper":"companyStatsTable_companyStatsTable-wrapper__vRuXP"};